import { Box } from "@mui/material";
import { styled } from '@mui/material/styles'


export const CardContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "white",
  padding: "33px 46px",
  height: "128px",
  width: "175px",
  columnGap: "10px",
  boxShadow: `0px 6px 20px 0px ${theme.colors.action.hoverShadow}`

}));